import React from 'react';
import {Grid} from "@material-ui/core";
import testImage from "../../assets/images/test.webp";
import {Download,ShoppingCart} from "../../assets/images/images";
import {APP_DOMAIN_PREFIX} from '../../environment';
function BoughtTogether(props) {
  const {data} = props;
  data.length = 3
  return (
    <Grid xs={12} md={3} style={{}}>
      <h2 style={{paddingLeft: 40}} className='font-30'> Bought Together</h2>
      <div style={{paddingLeft: 40}}>
        {data.map((item, key) => {
              let position = item.imagePath?.search("userImages");
              let imageUrl = APP_DOMAIN_PREFIX + item.imagePath;
              if(position == -1)
              imageUrl = APP_DOMAIN_PREFIX + "/userImages/" + item.imagePath;
  
          return (
            <Grid container md={12} alignItems='center' className='mt-20' direction='row'>
              <Grid md={5} className=''>
                 <img src={imageUrl } style={{width: '95%', height: 130}} alt='img' className='main-img'/>
              </Grid>
              <Grid md={6} className='pl-10'>
                <div>
                  <p className='m-0 font-18 text-bold text-capitalize '>{item?.harvest}</p>
                  {/* <p className='m-0  font-12 discount-color text-capitalize'>framing</p> */}
                </div>
                <div className='display-flex align-items-center'>
                  <p className='text-bold '>{item && item.discountCapture > 0 ? item.currency + (Number(item.priceSetByVendor) - ((Number(item.priceSetByVendor) * Number(item?.discountCapture)/100))) :  item.currency + item.priceSetByVendor}</p>
                 {item && item.discountCapture > 0 && <p className='font-12 in-active-color line-through ml-20 '>{item.currency + item.priceSetByVendor}</p> }
                </div>
                {/* <button className='  add-cart-btn-small'>
                  <ShoppingCart/>
                  <span className='ml-10'>Add to cart</span>
                </button> */}
              </Grid>
            </Grid>
          )
        })}
      </div>
    </Grid>
  );
}

export default BoughtTogether;
